import { Typography } from '@breetometer/components';
import { BreadcrumbAngleIcon, LeftIcon } from 'BreetAssets';
import { formatDisplayString, GenerateBreadcrumb, type IBreadcrumbs } from 'BreetHelpers';
import { Fragment } from 'react';
import { Link, useLocation } from 'react-router';

const BreadCrumbs = ({ noHome, pageTitle, activeLinkUrl }: IBreadcrumbs) => {
	const location = useLocation();
	const pathname = location.pathname;

	const dynamicBreadcrumbList = GenerateBreadcrumb(pathname);

	const hasHomeBreadcrumb = dynamicBreadcrumbList.some((path) => path.label === 'Home');

	const breadcrumbOptions =
		hasHomeBreadcrumb || noHome ? [...dynamicBreadcrumbList] : [{ label: 'Home', url: '/' }, ...dynamicBreadcrumbList];

	const activePath = breadcrumbOptions.length ? breadcrumbOptions[breadcrumbOptions.length - 1] : undefined;
	const activeLink = breadcrumbOptions.length ? breadcrumbOptions[breadcrumbOptions.length - 2] : undefined;

	return (
		<>
			<div className='breadcrumb border-bottom-primary-500'>
				{breadcrumbOptions.map((path, index) => (
					<Fragment key={path.label}>
						{index !== 0 && (
							<span>
								<LeftIcon />
							</span>
						)}
						<Link
							to={path.url}
							style={{ color: pathname === path.url ? '#05A2BF' : '#748181' }}
							className={pathname === path.url ? '' : 'color-primary-100'}
						>
							{index === breadcrumbOptions.length - 1 ? (pageTitle ?? path.label) : path.label}
						</Link>
					</Fragment>
				))}
			</div>
			<div className='breadcrumbmobile bg-primary-700 theme-border-none'>
				<div className='breadcrumbmobile_container'>
					<Link to={activeLinkUrl ?? activeLink?.url ?? ''}>
						<BreadcrumbAngleIcon
							className='breadcrumbmobile_link svg-dark'
							focusable
						/>
					</Link>
					<Typography className='breadcrumbmobile_title color-neutral-50'>
						{formatDisplayString(pageTitle ?? activePath?.label)}
					</Typography>
				</div>
			</div>
		</>
	);
};

export default BreadCrumbs;
